<template>
  <modal v-bind="$attrs" v-on="$listeners" :center="true">
    <template v-slot:body>
      <div class="content">
        <el-row type="flex" justify="center">
          <el-col>
            <div class="list">
              <h4 id="rename-title">
                {{$t('rename_assignment.rename_modal_title')}}
              </h4>
              <p v-if="is_rename_assignment_lib" id="rename-desc">{{$t('rename_assignment.rename_ass_lib_modal_desc')}}</p>
              <p v-else id="rename-desc">{{$t('rename_assignment.rename_entity_modal_desc')}}</p>
              <el-checkbox class="elsa-checkbox flex justify-center flex-row" label="consent" v-if="is_rename_assignment_lib" v-model.lazy="rename_ass_assigned">
                {{$t('rename_assignment.rename_checkbox_label')}}
              </el-checkbox>
            </div>
          </el-col>
        </el-row>
      </div>
    </template>
    <template v-slot:footer>
      <primary-button ref="" @click.native="handleEditName">
        {{ $t('common.got_it') }}
      </primary-button>
      <tertiary-button class="confirm-cancel" @click.native="$emit('closed')">
        {{ $t('common.cancel') }}
      </tertiary-button>
    </template>
  </modal>
</template>

<script>
import Modal from '@/components/common/Modal';
import PrimaryButton from '@/components/common/buttons/PrimaryButton';
import TertiaryButton from '@/components/common/buttons/TertiaryButton';
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    is_rename_assignment_lib: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rename_ass_assigned: false
    }
  },
  components: {
    Modal,
    PrimaryButton,
    TertiaryButton,
  },
  computed: {
  },
  methods: {
    handleEditName() {
      this.$emit('closed');
      this.$emit('edit', this.rename_ass_assigned);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../scss/_colors.scss';

.content {
  .list {
    max-width: 313px;
  }
  .detail {
    max-width: 300px;
  }
}

#rename-title {
  font-weight: 700;
  font-size: 22px;
  line-height: 32px;
  text-align: center;
  color: $black;
  margin: 0 auto;
}

#rename-desc {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: $black;
  margin: 15px auto 0 auto;
}

.elsa-button.confirm-cancel,
.elsa-button.confirm-cancel:hover {
  border-radius: 8px;
  padding-left: 16px;
  padding-right: 16px;
}

::v-deep {
  .el-dialog.elsa-modal {
    .el-dialog__header,
    .el-dialog__body {
      background-color: white;
      align-items: center;
    }

    &.signup .el-dialog__body {
      padding: 0;
    }

    .el-dialog__header {
      border-top-left-radius: 16px;
      border-top-right-radius: 16px;
      min-height: 27.5px;
    }

    .el-dialog__body {
      border-top: none;
      & > *:not(p):not(.info) {
        padding-bottom: 6px;
        display: flex;
        flex-direction: column;
      }
    }

    .el-dialog__footer {
      padding: 0 20px 48px 20px;
      justify-content: center;
    }
  }
}
</style>
